// extracted by mini-css-extract-plugin
module.exports = {"PageLoader":"PageLoader_PageLoader__3SxS9"};